import { Quote } from "lucide-react";

export default function About() {
  return (
    <section
      data-testid="about-section"
      className="relative bg-sand-100 py-24 lg:py-36 overflow-hidden grain"
    >
      <div className="max-w-[1440px] mx-auto px-6 lg:px-10">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-center">
          {/* Image collage */}
          <div className="lg:col-span-6 relative">
            <div className="grid grid-cols-5 grid-rows-6 gap-4 aspect-[4/5] max-w-xl">
              <div className="col-span-3 row-span-6 overflow-hidden bg-sand-200">
                <img
                  src="https://customer-assets.emergentagent.com/job_flavios-salon/artifacts/emyskobq_Snapchat-9546986.jpg"
                  alt="Stylist chair with hair art on wall"
                  className="w-full h-full object-cover img-hover"
                  style={{ filter: "contrast(1.08) saturate(1.05) brightness(1.05)", imageRendering: "auto" }}
                />
              </div>
              <div className="col-span-2 row-span-3 col-start-4 row-start-1 overflow-hidden bg-sand-200">
                <img
                  src="https://customer-assets.emergentagent.com/job_flavios-salon/artifacts/zaqqkbj9_Snapchat-469937218.jpg"
                  alt="In-salon retail wall — Design.Me, Moroccan Oil"
                  className="w-full h-full object-cover img-hover"
                  style={{ filter: "contrast(1.06) saturate(1.18) brightness(1.03)" }}
                />
              </div>
              <div className="col-span-2 row-span-3 col-start-4 row-start-4 overflow-hidden bg-sand-200">
                <img
                  src="https://customer-assets.emergentagent.com/job_flavios-salon/artifacts/p0x7anyg_Snapchat-1877419641.jpg"
                  alt="Salon interior — styling stations"
                  className="w-full h-full object-cover img-hover"
                  style={{ filter: "contrast(1.08) saturate(1.12) brightness(1.04)" }}
                />
              </div>
            </div>
          </div>

          {/* Team text */}
          <div className="lg:col-span-6 lg:pl-8">
            <span className="overline">Meet The Team</span>
            <h2 className="mt-6 font-serif font-light text-5xl lg:text-6xl text-ink-900 leading-[1.05] tracking-tight">
              Highly trained.<br />
              <span className="italic text-gold">Deeply passionate.</span>
            </h2>
            <p className="mt-8 text-lg text-ink-500 leading-relaxed max-w-lg">
              Our stylists are Schwarzkopf Professional, Moroccan Oil and
              Design.Me partners — the same standards used in the world&apos;s top
              editorial studios. We bring them to a neighbourhood chair in
              Mississauga.
            </p>

            <div className="mt-10 p-8 bg-sand-50 border-l-2 border-gold relative">
              <Quote className="absolute -top-4 left-6 w-8 h-8 text-gold fill-gold" />
              <p className="font-serif italic text-2xl lg:text-3xl text-ink-900 leading-snug">
                &ldquo;We don&apos;t just cut hair. We spend the time to understand
                what makes you feel like you.&rdquo;
              </p>
              <p className="mt-4 text-xs tracking-[0.2em] uppercase text-ink-500">
                — Flavio&apos;s Team
              </p>
            </div>

            <div className="mt-10 grid grid-cols-3 gap-6">
              {[
                { k: "Schwarzkopf", v: "Colour" },
                { k: "Moroccan Oil", v: "Care" },
                { k: "K18", v: "Repair" },
                { k: "Oligo", v: "Blonde" },
                { k: "Design.Me", v: "Styling" },
              ].map((b) => (
                <div key={b.k} className="border-t border-black/20 pt-4">
                  <p className="font-serif text-xl text-ink-900">{b.k}</p>
                  <p className="text-xs tracking-[0.15em] uppercase text-ink-500 mt-1">
                    {b.v}
                  </p>
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}
